export default __webpack_public_path__ + "static/apres-season-717860817b397015aca4a0fe915b7c07.webp";